import { DatePicker, Flex } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dayjs } from "dayjs";
import { RequiredItem } from "@/pages/Requirement/style";
import { Requirement, RequirementStatusEnum } from "@/types/requirement";
import { PageId } from "@/types/page";

interface ProdInputProps {
  pageId: PageId | undefined;
  detail: Requirement | undefined;
}

export interface ProdInputRef {
  getValues: () => {
    mrd: Dayjs | null,
    eps: Dayjs | null,
    preFinishDate: Dayjs | null
  };
}


const ProdInput = forwardRef<ProdInputRef, ProdInputProps>(({
  pageId, detail
}, ref) => {
  const { t } = useTranslation();

  const [mrd, setMrd] = useState<Dayjs | null>(null);
  const [eps, setEps] = useState<Dayjs | null>(null);
  const [preFinishDate, setPreFinishDate] = useState<Dayjs | null>(null);

  useImperativeHandle(ref, () => ({
    getValues: () => ({ mrd, eps, preFinishDate })
  }));

  return (
    <>
      {
        ((pageId === PageId.PROD_NOT_PASS && detail?.status !== RequirementStatusEnum.CLOSE) || (pageId === PageId.MC_NOT_PASS)) && (
          <Flex gap={20}>
            <Flex gap={5}>
              <RequiredItem className="requirement-required">*</RequiredItem>
              <span>{t("requirement.mrd")}</span>
              <DatePicker onChange={setMrd} value={mrd} />
            </Flex>
            <Flex gap={5}>
              <RequiredItem className="requirement-required">*</RequiredItem>
              <span>{t("requirement.eps")}</span>
              <DatePicker onChange={setEps} value={eps} />
            </Flex>
            <Flex gap={5}>
              <RequiredItem className="requirement-required">*</RequiredItem>
              <span>{t("sale.preFinishDate")}</span>
              <DatePicker onChange={setPreFinishDate} value={preFinishDate} />
            </Flex>
          </Flex>
        )
      }
    </>
  )
});

export default ProdInput;